import { render, staticRenderFns } from "./decorateList.vue?vue&type=template&id=30f8bd2d&scoped=true&"
import script from "./decorateList.vue?vue&type=script&lang=js&"
export * from "./decorateList.vue?vue&type=script&lang=js&"
import style0 from "./decorateList.vue?vue&type=style&index=0&id=30f8bd2d&scoped=true&lang=less&"
import style1 from "./decorateList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f8bd2d",
  null
  
)

export default component.exports